import { useEffect, useState } from 'react';
import axios from 'axios';

import '../App.css';

const Weather = (props) => {
  const [weatherData, setWeatherData] = useState({})
  const urlParams = new URLSearchParams(window.location.search);
  const rid = urlParams.get('rid');

  useEffect(() => {
    getWeatherData();

    setInterval(() => {
      getWeatherData();
    }, 1000 * 60 * 15)
  }, [])

  const getWeatherData = async () => {
    const res = await axios.get(`https://iot.univertech.cn/house/bscreen/weather/?hid=${props.hid}&rid=${rid}`);
    const { data, status } = res;
    if (status === 200) {
      setWeatherData(data.data);
    }
  }

  const { city, temp, tempMax, tempMin, hours  } = weatherData;

  return (
    <div className="card weather">
      <h3 className="card-title">天气预报</h3>
      <div className="card-body">
        <div className="weather-container">
          <div className="header-info">
            <div className="city">
              <span>{ city }</span>
              { temp }度
            </div>
            <div className="detail">
              <span>{ weatherData.weather }</span>
              <p>最高 {tempMax}  最低 {tempMin}</p>
            </div>
          </div>
          <ul className="hour-list">
            {hours && hours.map((item, index) => (
              <li key={index}>
                <div className="hour">
                  <span>{ item.name }</span>
                  <span>{ item.weather }</span>
                  <span>{ item.temp }</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Weather;
